import React from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from '../Tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ChangelogTagTooltip = ({ id, statusChangelog }) => {
  const { t } = useTranslation()
  return (
    <Tooltip
      id={id}
      content={t(`changelog.filter.changeType.flags.${statusChangelog.toLowerCase()}.tooltip`)}
      tooltipProps={{ place: 'top' }}
    >
      <FontAwesomeIcon icon={['fal', 'info-circle']} />
    </Tooltip>
  )
}

export default ChangelogTagTooltip
